// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__LjaaS","compact":"styles_compact__T87GC","iconWrap":"styles_iconWrap__gznGr","title":"styles_title__EPdmV","description":"styles_description__+0-eH"};